export default "__VITE_ASSET__CBGV1cFF__"